import { DeviceDef } from "../types/group.type";

export const getDeviceName = (device: DeviceDef | null) => {
  return device && device.name ? device.name : "Thiết bị không xác định";
};
